import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useFinalizePayment } from '../../services/api/subscription-api';

const Wrapper = styled.div`
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: var(--bg-main);
  color: var(--text-main);
  padding: 2rem;
`;

const Card = styled.div`
  width: min(560px, 100%);
  background: var(--bg-card);
  border-radius: 18px;
  padding: 2.5rem;
  box-shadow: 0 12px 30px rgba(0,0,0,0.18);
  text-align: center;
`;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function PurchaseCancelPage() {
  const query = useQuery();
  const navigate = useNavigate();
  const { mutate: finalizePayment } = useFinalizePayment();
  const [loading, setLoading] = useState(true);
  const paymentId = query.get('payment_id');
  const sessionId = query.get('session_id');
  const receivedPaymentId = paymentId || query.get('paymentId');

  useEffect(() => {
    if (!paymentId && !sessionId) {
      setLoading(false);
      return;
    }

    finalizePayment(
      { payment_id: receivedPaymentId, session_id: sessionId, status: 'failed' },
      {
        onSettled: () => setLoading(false),
      }
    );
  }, [receivedPaymentId, sessionId, finalizePayment]);

  return (
    <Wrapper>
      <Card>
        <h1>Payment cancelled</h1>
        <p>No charge was completed. You can try again whenever you're ready.</p>
        <button disabled={loading} onClick={() => navigate('/default/templates')}>Back to templates</button>
      </Card>
    </Wrapper>
  );
}